import CALL_API from '../../middleware/api_key';
import { Schemas } from '../../middleware/schemas';
import { UnleashFeatureNames } from '../../modules/Unleash/featureNames';
import { getIsFeatureEnabled } from '../../selectors/features';
import { getUser } from '../../selectors/user';

export const Actions = {
  FETCH_ME_REQUEST: 'glints/user/me/FETCH_ME_REQUEST',
  FETCH_ME_SUCCESS: 'glints/user/me/FETCH_ME_SUCCESS',
  FETCH_ME_FAILURE: 'glints/user/me/FETCH_ME_FAILURE',

  PERSIST_ME_REQUEST: 'glints/user/me/PERSIST_ME_REQUEST',
  PERSIST_ME_SUCCESS: 'glints/user/me/PERSIST_ME_SUCCESS',
  PERSIST_ME_FAILURE: 'glints/user/me/PERSIST_ME_FAILURE',
};

const mapEmployerCompany = company => ({
  ...company,
  displayName: company.displayName || company.name,
  UserCompany: company.userCompany,
});

// The v2 /me endpoint flattens pendingUserCompany.status, while v1 nests it
// under PendingUserCompany.status. Normalize so consumers can read either shape.
const normalizePendingUserCompany = company => ({
  ...company,
  status: company.status ?? company.PendingUserCompany?.status,
  PendingUserCompany: company.PendingUserCompany ?? { status: company.status },
});

// can delete transform if we fully migrate the /me into v2
// the current PUT making us to use this method for backward compatibility with v1 models
const transformFetchMeResponse = response => {
  const me = response.data.data;
  const companies = (me.companies || []).map(mapEmployerCompany);
  const pendingUserCompanies = (me.pendingUserCompanies || []).map(
    normalizePendingUserCompany
  );

  return {
    ...response,
    data: {
      ...response.data,
      data: {
        ...me,
        CityId: me.CityId ?? me.cityId,
        CountryCode: me.CountryCode ?? me.countryCode,
        LocationId: me.LocationId ?? me.hierarchicalLocation?.id ?? null,
        Nationality: me.Nationality ?? me.nationality,
        companies,
        links: {
          ...me.links,
          city: me.city,
          companies,
          country: me.country,
          pendingUserCompanies,
        },
        pendingUserCompanies,
      },
    },
  };
};

export function fetchMe() {
  return async (dispatch, getState) => {
    // Feature flags are not loaded yet during the initial SessionInitializer
    // bootstrap, so default to the v1 endpoint (flag OFF) until they arrive.
    // useRefetchMeForV2Migration triggers a subsequent v2 fetch when the flag
    // is enabled and the flags have been fetched.
    const isMigrateMeToV2Enabled = getIsFeatureEnabled(
      getState(),
      UnleashFeatureNames.empMigrateMeToV2
    );

    await dispatch({
      [CALL_API]: {
        types: [
          Actions.FETCH_ME_REQUEST,
          Actions.FETCH_ME_SUCCESS,
          Actions.FETCH_ME_FAILURE,
        ],
        endpoint: isMigrateMeToV2Enabled ? 'v2/me/employer' : 'me',
        schema: Schemas.USER,
        ...(isMigrateMeToV2Enabled && {
          responseTransformer: transformFetchMeResponse,
        }),
        ...(!isMigrateMeToV2Enabled && {
          options: {
            params: {
              include: 'Companies, PendingUserCompanies, City, Country',
            },
          },
        }),
      },
    });
  };
}

export function saveUserFeatures(feature) {
  return async (dispatch, getState) => {
    const preferences = getUser(getState())?.preferences ?? {};
    preferences.features = preferences.features || {};
    preferences.features[feature] = true;
    await dispatch(persistMe({ preferences: preferences }));
  };
}

export function persistMe(values) {
  return async dispatch => {
    await dispatch({
      [CALL_API]: {
        types: [
          Actions.PERSIST_ME_REQUEST,
          Actions.PERSIST_ME_SUCCESS,
          Actions.PERSIST_ME_FAILURE,
        ],
        endpoint: 'me',
        schema: Schemas.USER,
        method: 'put',
        options: {
          data: values,
        },
      },
    });
  };
}
